import React from "react";
import "../style/shared/MainContent.css";
import AssetForm from "../components/Asset/AssetForm";
import Dashboard from "../components/Dashboard/Dashboard";
import AssetsTable from "../components/Asset/AssetsTable";
import LocationForm from "../components/Location/LocationForm";
import Settings from "../pages/SettingsPage";
import LocationTable from "../components/Location/LocationTable";
import Home from "../components/Home/Home";
import ProfilePage from "../pages/ProfilePage";
import TreeViewPage from "../pages/TreeViewPage";
import ActivityLogPage from "../pages/ActivityLogPage";
import TagsPage from "../pages/TagsPage";
import BulkQRPage from "../pages/BulkQRPage";
import KuttIntegrationPage from "../pages/KuttIntegrationPage";
import AssetQuickSaveForm from "../components/Asset/AssetQuickSaveForm";
import APITokenPage from "../pages/APITokenPage";
import SmtpConfigPage from "../pages/SmtpConfigPage";
import UserManagementPage from "../pages/UserManagementPage";
import ScanRegistrationSelectionPage from "../pages/ScanRegistrationSelectionPage";
import LocationQuickSaveForm from "../components/Location/LocationQuickSaveForm";

/**
 * MainContent component that dynamically selects and renders the appropriate page component 
 * based on the provided `selectedPage` prop.
 * 
 * @param {Object} props - The props object passed to the component.
 * @param {string} props.selectedPage - The name of the page to render (e.g., "dashboard", "add_asset", etc.).
 * @returns {JSX.Element} The corresponding page component based on the selectedPage.
 */

const MainContent = ({ selectedPage, className }) => {
  let ComponentToRender;

  const mainClass = `main-content ${className}`;

  const [config, setConfig] = React.useState(null);

  React.useEffect(() => {
    import("../services/systemConfigService").then(service => {
      service.default.getConfig().then(data => setConfig(data));
    });
  }, []);

  switch (selectedPage) {
    case "home":
    case "scanner":
      ComponentToRender = Home;
      break;
    case "dashboard":
      ComponentToRender = Dashboard;
      break;
    case "profile":
      ComponentToRender = ProfilePage;
      break;
    case "tree_view":
      ComponentToRender = TreeViewPage;
      break;
    case "add_asset":
      ComponentToRender = AssetForm;
      break;
    case "scan_registration":
      ComponentToRender = ScanRegistrationSelectionPage;
      break;
    case "add_scanned_asset":
      ComponentToRender = (config && config.registrationFlow === "PHOTO_FIRST") 
        ? AssetQuickSaveForm 
        : AssetForm;
      break;
    case "view_asset":
      ComponentToRender = AssetsTable;
      break;
    case "add_location":
      ComponentToRender = LocationForm;
      break;
    case "view_location":
    case "containers":
      ComponentToRender = LocationTable;
      break;
    case "tags":
      ComponentToRender = TagsPage;
      break;
    case "settings":
      ComponentToRender = Settings;
      break;
    case "activity_log":
      ComponentToRender = ActivityLogPage;
      break;
    case "kutt_integration":
      ComponentToRender = KuttIntegrationPage;
      break;
    case "api_tokens":
      ComponentToRender = APITokenPage;
      break;
    case "smtp_config":
      ComponentToRender = SmtpConfigPage;
      break;
    case "bulk_qr":
      ComponentToRender = BulkQRPage;
      break;
    case "users":
    case "user_management":
      ComponentToRender = UserManagementPage;
      break;
    default:
      ComponentToRender = Home;
    //ComponentToRender = () => <div>Select a menu item to begin.</div>;
  }

  return (
    <div className={mainClass}>
      <ComponentToRender />
    </div>
  );
};

export default MainContent;
